import "core-js";
import "whatwg-fetch";

import ready from "./core/ready";

import GeckoSlideshow from "./components/slideshow";
import Timeline from "./components/timeline";
import LocationMap from "./components/location-map";

import "./weak";

ready(() => {
	// Load Location Map if elements exist
	let locationMap = new LocationMap();

	const swiperConts = Array.from(
		document.querySelectorAll(".swiper-container")
	);

	for (const el of swiperConts) {
		const slideshow = new GeckoSlideshow(<HTMLElement>el);
	}

	// Timeline
	const timeLineBlocks = Array.from(
		document.querySelectorAll(".text-timeline__item")
	);
	if (timeLineBlocks.length > 0) {
		for (let block of timeLineBlocks) {
			const view = new Timeline(block, 0.8);
		}
	}
});
